module.exports = __webpack_public_path__ + "img/default_pic_4_3.84e6be83.png";